// extracted by mini-css-extract-plugin
export default {"carousel":"Portfolio_carousel__TDImz"};